/**
 * Minimum target size (redesign phase 6, #455, consistency finding #3): WCAG
 * 2.2 SC 2.5.8 asks for a 24×24 hit area. Where the look is decided smaller
 * (Switch, Checkbox, Chip remove, Disclosure `sm`, ConfidenceBadge, sort
 * buttons, InfoTooltip), the hit area grows instead of the visual: an
 * invisible `::before`, centred on the element, at least 24×24 and never
 * smaller than the element itself. Pointer events on a pseudo element land on
 * its host, so the click reaches the control.
 *
 * The host needs `position: relative` (included). Nothing else may use the
 * host's `::before`.
 */
export const HIT_AREA =
  "relative before:absolute before:top-1/2 before:left-1/2 before:size-full before:min-h-6 before:min-w-6 " +
  "before:-translate-x-1/2 before:-translate-y-1/2";
